<script>
import {mapActions, mapMutations, mapGetters} from 'vuex';
import edit from './codeEdit';
import config from '@/modules/config/columns';
export default {
	created() {
	},
	props: {
		handlerSearch: {
			type: Function,
			required: true
		},
		searchQuery: {
			type: Object,
			required: true
		},
		selectOption: {
			type: Object,
			required: true
		}
	},
	data() {
        return {
        }
    },
	methods: {
		addModel() {
			this.$emit('handleAdd');
		},
        change(value, type) {
			this.$emit('change', {value, type});
		},
		reset() {
			this.$clearObject(this.searchQuery);
		},
		...mapActions('zft', ['carouseAdd']),
	},
	computed: {
		...mapGetters('nameRules', ['codeOption']),
		config() {
			return config;
		}
	},
	components: {
		edit
	}
}
</script>
<template>
<div class="name-search">
	<el-row :gutter="20">
	    <el-col :span="6">
	        <el-input v-model="searchQuery.title" @change="change($event, 'title')" placeholder="项目标题"></el-input>
	    </el-col>
	    <el-col :span="6">
			<el-select v-model="searchQuery.provinceId" class="common-width"
			   placeholder="省份选择"
			   @change="change($event, 'provinceId')"
			>
				<el-option
					v-for="item in selectOption.provinceId"
					:key="item.districtId"
					:label="item.districtName"
					:value="item.districtId"
				>
				</el-option>
			</el-select>
	    </el-col>
		<el-col :span="6">
			<el-select v-model="searchQuery.cityId" class="common-width"
			   placeholder="城市选择"
			   @change="change($event, 'cityId')"
			>
				<el-option
					v-for="item in selectOption.cityId"
					:key="item.districtId"
					:label="item.districtName"
					:value="item.districtId"
				>
				</el-option>
			</el-select>
	    </el-col>

        <el-col :span="6">
			<el-select v-model="searchQuery.channelType" class="common-width"
			    placeholder="频道栏目"
				@change="change($event, 'channelType')"
			>
                <el-option :value=1 label="专题频道"></el-option>
			</el-select>
	    </el-col>
	</el-row><br/>
	<el-row :gutter="20">
         <el-col :span="6">
			<el-select v-model="searchQuery.firstTradeId" class="common-width"
			    placeholder="一级行业"
				@change="change($event, 'firstTradeId')"
			>
				<el-option
					v-for="item in selectOption.firstTradeId"
					:key="item.tradeId"
					:label="item.tradeName"
					:value="item.tradeId"
				>
				</el-option>
			</el-select>
	    </el-col>
        <el-col :span="6">
			<el-select v-model="searchQuery.secondTradeId" class="common-width"
			    placeholder="二级行业"
				@change="change($event, 'secondTradeId')"
			>
				<el-option
					v-for="item in selectOption.secondTradeId"
					:key="item.tradeId"
					:label="item.tradeName"
					:value="item.tradeId"
				>
				</el-option>
			</el-select>
	    </el-col>
        <el-col :span="6">
			<el-date-picker
			    class="common-width"
				v-model="searchQuery.queryTimeBegin"
				type="date"
				placeholder="选择发布开始日期"
				value-format="yyyy-MM-dd"
				@change="change"
			>
			</el-date-picker>
	    </el-col>
        <el-col :span="6">
			<el-date-picker
			    class="common-width"
				v-model="searchQuery.queryTimeEnd"
				type="date"
				placeholder="选择发布结束日期"
				value-format="yyyy-MM-dd"
				@change="change"
			>
			</el-date-picker>
	    </el-col>
	</el-row><br/>
	<el-row :gutter="20">
		<el-col :span="12">
	        <el-button type="primary" @click="handlerSearch">搜索</el-button>
	        <el-button type="primary" @click="reset">重置</el-button>
	        <el-button type="primary" @click="addModel">新增</el-button>

	    </el-col>
	</el-row>
</div>
</template>
<style scoped lang="stylus">
.el-header
    line-height 60px
    padding 0 10px
.avatar-uploader
    display inline-block
    margin-left 80%

/deep/.el-date-editor.el-input, .el-date-editor.el-input__inner
    width auto
</style>
